var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.238 16.795L11.0197 11.5767C10.603 11.9317 10.1238 12.2064 9.58216 12.4009C9.04049 12.5953 8.49605 12.6925 7.94883 12.6925C6.61438 12.6925 5.48494 12.2306 4.56049 11.3067C3.63605 10.3828 3.17383 9.25365 3.17383 7.9192C3.17383 6.58476 3.63549 5.45504 4.55883 4.53004C5.48216 3.60504 6.61105 3.14198 7.9455 3.14087C9.27994 3.13976 10.4099 3.60198 11.3355 4.52754C12.2611 5.45309 12.7238 6.58282 12.7238 7.9167C12.7238 8.49559 12.6213 9.05587 12.4163 9.59754C12.2113 10.1392 11.9419 10.6025 11.608 10.9875L16.8263 16.205L16.238 16.795ZM7.94966 11.8584C9.05522 11.8584 9.98855 11.4778 10.7497 10.7167C11.5108 9.95559 11.8913 9.02198 11.8913 7.91587C11.8913 6.80976 11.5108 5.87643 10.7497 5.11587C9.98855 4.35532 9.05522 3.97476 7.94966 3.9742C6.84411 3.97365 5.91049 4.3542 5.14883 5.11587C4.38716 5.87754 4.00661 6.81087 4.00716 7.91587C4.00772 9.02087 4.38827 9.95421 5.14883 10.7159C5.90938 11.4775 6.84272 11.8581 7.94883 11.8575",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f060212d7b3ada183dff09673ff70f68.svg";
export { ForwardRef as ReactComponent };